import dayjs from 'dayjs';
import { z } from 'zod';

export const newEventSchema = z.object({
  title: z.string().nonempty('Title is verplicht'),
  location: z.string().nonempty('Locatie is verplicht'),
  branch: z.string().nonempty('Vestiging is verplicht'),
  description: z.string().optional(),
  startDate: z.any().refine(
    (dateString: string) => {
      const date = dayjs(dateString);
      const isValid = date && date.isValid();
      return isValid;
    },
    {
      message: 'Start datum is niet correct',
    }
  ),
  endDate: z
    .any()
    .refine(
      (dateString: string) => {
        if (!dateString) return true;
        const date = dayjs(dateString);
        const isValid = date && date.isValid();
        return isValid;
      },
      {
        message: 'Eind datum is niet correct',
      }
    )
    .optional(),
  image: z.any().optional(),
  maxAttendees: z.any(),
  private: z.boolean(),
});

export type NewEvent = z.infer<typeof newEventSchema>;
